import React from 'react'

interface CardProps {
  children: React.ReactNode
  textAlign?: 'center' | 'left'
  className?: string
}

const Card: React.FC<CardProps> = ({
  children,
  textAlign = 'center',
  className = ''
}) => {
  const variantStyles = {
    center: 'text-center',
    left: 'text-left'
  }

  return (
    <section className={`py-8 bg-surface rounded-xl max-w-4xl mx-auto px-8 ${variantStyles[textAlign]} ${className}`}>
      <div className="text-lg text-text-light leading-relaxed">
        {children}
      </div>
    </section>
  )
}

export default Card